module.exports = __webpack_public_path__ + "static/mentor-shivdeep-1663955e7d885b2d5476bfd181c5fe30.jpg";